import {ApolloClient, HttpLink} from '@apollo/client';
import {InMemoryCache, NormalizedCacheObject, PossibleTypesMap} from '@apollo/client/cache';
import fetch from 'cross-fetch';
// eslint-disable-next-line import/extensions
import fragmentTypes from '@src/graphql/directConnectPortedTypes.json';
import Environment from '../../../directConnectPortOver/constants/Environment';
import getGraphEndpoint from '../../../directConnectPortOver/utils/getGraphEndpoint';

interface Props {
  cookie?: string;
  environment?: Environment;
  graphQLEndpoint?: string;
  initialState?: NormalizedCacheObject;
  ssrMode?: boolean;
}

const introspectionToPossibleTypes = (introspectionQueryResultData: any): PossibleTypesMap => {
  const possibleTypes = {} as any;

  // eslint-disable-next-line no-underscore-dangle
  introspectionQueryResultData.__schema.types.forEach((supertype: any) => {
    if (supertype.possibleTypes) {
      possibleTypes[supertype.name] = supertype.possibleTypes.map((subtype: any) => subtype.name);
    }
  });

  return possibleTypes;
};

const createDirectConnectClient = ({
  cookie,
  environment,
  graphQLEndpoint,
  initialState = {},
  ssrMode = false,
}: Props = {}) => {
  const cache = new InMemoryCache({
    possibleTypes: introspectionToPossibleTypes(fragmentTypes),
  }).restore(initialState);

  const headers = cookie ? {cookie} : undefined;

  const link = new HttpLink({
    uri: graphQLEndpoint || getGraphEndpoint(environment),
    credentials: 'include',
    headers,
    fetch,
  });

  const client = new ApolloClient({
    cache,
    link,
    ssrMode,
  });

  return client;
};

export default createDirectConnectClient;
